<template>
  <div>
    <div class="material-gallery">
      <div v-for="(image, i) in images" :key="`image-${i}`"
            class="pointer"
            @click="openLightbox(i)">
        <div class="picture mb-2 mb-md-3 mx-auto" :style="{'background-image': `url(${image.image.sizes.medium}})`}"></div>
        <div v-if="image.caption"
              class="picture-caption">
          <span :class="{'picture-caption-single': image.caption.length <= 2}">
            {{image.caption}}
          </span>
        </div>
      </div>
    </div>
    <div>
      <CoolLightBox
        :items="lightboxItems"
        :index="lightboxIndex"
        :slideshow="false"
        :thumbsPosition="'bottom'"
        @close="lightboxIndex = null">
      </CoolLightBox>
    </div>
  </div>
</template>
<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  components: {
    CoolLightBox,
  },
  props: {
    images: null,
  },
  data() {
    return {
      lightboxItems: [],
      lightboxIndex: null,
    };
  },
  methods: {
    openLightbox(index) {
      const gallery = this.images.map((pic) => {
        const caption = pic.caption && pic.caption.length <= 2
          ? `<span class="picture-caption-single">${pic.caption}</span>` : pic.caption;
        return { src: pic.image.sizes['2048x2048'], description: caption };
      });
      this.lightboxItems = gallery;
      this.lightboxIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.material-gallery {
  display: flex;
  flex-wrap: wrap;
  > div {
    max-width: 30%;
    width: 100%;
    padding: 10px;
    @include media-breakpoint-down(sm) {
      max-width: 50%;
    }
    img {
      transition: all .3s ease-in-out;
      background: white;
      max-height: 200px;
    }
  }
  .picture {
    max-width: 200px;
    width: 100%;
    height: 200px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    transition: all .3s ease-in-out;
    background-color: white;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    &:hover {
      transform: scale(1.5);
      box-shadow: 0px 0px 0px 1px #e0e0e0;
    }
    @include media-breakpoint-down(sm) {
      height: 100px;
      max-width: 100px;
    }
  }
  .picture-caption {
    text-align: center;
    font-size: 14px;
  }
}
</style>
